const stopPropagation = (e) => e.stopPropagation()

export default stopPropagation
